import React from 'react';
import PropTypes from 'prop-types';
import {DrawerHandle} from '@learningblocks/exp-components';
import {Image, GlossaryProvider} from '@learningblocks/storybook-components';
import GlossaryIcon from './Glossary.Icon.svg';

export function NotebookSectionsHeader(props) {

  const {onOpenGlossary} = React.useContext(GlossaryProvider.Context);

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onOpenGlossary('');
  };

  return (
    <div className='notebook-sections__header'>
      <DrawerHandle />
      <span className='title'>
        <h6 style={{transformText: "uppercase"}}>{props.level}</h6>
        <h5>Gel electrophoresis of the <i>TAS2R38</i> gene</h5>
      </span>
      <span className='glossaryButton' onClick={onClick}>
        <Image src={GlossaryIcon} alt='glossary icon' />
        <h5>Glossary</h5>
      </span>
    </div>
  );
}
NotebookSectionsHeader.propTypes = {
  level: PropTypes.string
};
